import { Table } from 'antd';
import moment from 'moment';
import React from 'react';
import { DAYTIME_FORMAT, DAY_FORMAT } from '../../constants';
import isNumber from 'lodash/isNumber';
import './RoutePlansTable.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const RoutePlansTable = ({ withAction, dataSource, selectedRowKeys, onSelectChange, ...props }) => {
  const columns = [
    {
      title: 'Route Name',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      width: 150,
      render: (value, row) => {
        return <Link to={'routes/' + row.slug}>{value}</Link>;
      },
    },
    {
      title: 'Date',
      dataIndex: 'deliveryDate',
      key: 'deliveryDate',
      width: 150,
      render: (value) => {
        return value ? moment(value).format(DAY_FORMAT) : '';
      },
    },
    {
      title: '# of Orders',
      dataIndex: 'totalStops',
      key: 'totalStops',
      width: 120,
      render: (value) => {
        return isNumber(value) ? Number(value) : '';
      },
    },
    {
      title: '# of Drivers',
      dataIndex: 'totalDrivers',
      key: 'totalDrivers',
      width: 120,
      render: (value) => {
        return isNumber(value) ? Number(value) : '';
      },
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 'region',
    },
    {
      title: 'Distance',
      dataIndex: 'distance',
      key: 'distance',
      render: (value) => {
        return isNumber(value) ? (value / 1000).toFixed(2) + ' km' : '';
      },
    },
    {
      title: 'Travel Time',
      dataIndex: 'travelTime',
      key: 'travelTime',
      render: (value) => {
        return isNumber(value) ? value + ' mins' : '';
      },
    },
    {
      title: 'Working Time',
      dataIndex: 'workingTime',
      key: 'workingTime',
      render: (value) => {
        return isNumber(value) ? value + ' mins' : '';
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: 130,
      fixed: 'right',
      render(status) {
        return (
          <span className={'routePlanStatus ' + status}>
            <div className="circle"></div>
            {status}
          </span>
        );
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 120,
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-route-plans table-common">
      <Table
        columns={columns}
        rowSelection={rowSelection}
        scroll={{ x: 1800 }}
        dataSource={dataSource}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
};

export default RoutePlansTable;
